"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceChangePopupDesktop = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../Button"));
var _CurrencyFormat = _interopRequireDefault(require("../../CurrencyFormat"));
var _ArrowRightLong = _interopRequireDefault(require("../../../icons-react/userflow/ArrowRightLong"));
var _HotPriceCircle = _interopRequireDefault(require("../../../icons-react/userflow/HotPriceCircle"));
var _constants = require("../constants");
var _utils = require("../utils");
var PriceChangePopupDesktop = exports.PriceChangePopupDesktop = function PriceChangePopupDesktop(props) {
  var oldPrice = props.oldPrice,
    newPrice = props.newPrice,
    onOrderConfirmed = props.onOrderConfirmed,
    hotelLink = props.hotelLink,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  var _getPriceDirection = (0, _utils.getPriceDirection)({
      oldPrice: oldPrice,
      newPrice: newPrice
    }),
    priceDirection = _getPriceDirection.priceDirection,
    isDecreased = _getPriceDirection.isDecreased,
    isIncreased = _getPriceDirection.isIncreased;
  var _PRICE$priceDirection = _constants.PRICE[priceDirection],
    title = _PRICE$priceDirection.title,
    description = _PRICE$priceDirection.description,
    buttonText = _PRICE$priceDirection.buttonText;
  return /*#__PURE__*/_react["default"].createElement(StyledPriceChangePopup, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Title, null, title), /*#__PURE__*/_react["default"].createElement(Description, {
    priceIncreased: isIncreased
  }, description), /*#__PURE__*/_react["default"].createElement(PriceDiff, null, /*#__PURE__*/_react["default"].createElement(OldPrice, null, /*#__PURE__*/_react["default"].createElement(PriceTitle, null, "\u0421\u0442\u0430\u0440\u0430\u044F \u0446\u0435\u043D\u0430"), /*#__PURE__*/_react["default"].createElement(Amount, {
    value: oldPrice
  })), /*#__PURE__*/_react["default"].createElement(Separator, null, /*#__PURE__*/_react["default"].createElement(Arrow, null)), /*#__PURE__*/_react["default"].createElement(NewPrice, null, /*#__PURE__*/_react["default"].createElement(PriceTitle, null, "\u0424\u0438\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0446\u0435\u043D\u0430"), /*#__PURE__*/_react["default"].createElement(Amount, {
    value: newPrice
  }))), /*#__PURE__*/_react["default"].createElement(Buttons, null, isIncreased && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(HotelLinkWrapper, null, hotelLink && /*#__PURE__*/_react["default"].createElement(HotelLink, {
    as: "a",
    target: "_blank",
    functional: true,
    href: hotelLink
  }, 'Посмотреть другие\n туры в этот отель')), /*#__PURE__*/_react["default"].createElement(Separator, null)), /*#__PURE__*/_react["default"].createElement(PaymentButton, {
    primary: true,
    size: "flex",
    onClick: onOrderConfirmed,
    priceDecreased: isDecreased
  }, isDecreased && /*#__PURE__*/_react["default"].createElement(FireIcon, null), buttonText, /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    prefix: " \u0437\u0430 ",
    value: newPrice
  }))));
};
var StyledPriceChangePopup = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupDesktop__StyledPriceChangePopup",
  componentId: "sc-ieg9kh-0"
})(["width:552px;padding:0;display:flex;flex-direction:column;align-items:center;background-color:#fff;text-align:center;"]);
var Separator = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupDesktop__Separator",
  componentId: "sc-ieg9kh-1"
})(["display:flex;align-items:center;justify-content:center;min-width:50px;"]);
var Arrow = (0, _styledComponents["default"])(_ArrowRightLong["default"]).withConfig({
  displayName: "PriceChangePopupDesktop__Arrow",
  componentId: "sc-ieg9kh-2"
})(["width:51px;height:15px;margin-top:13px;"]);
var Title = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupDesktop__Title",
  componentId: "sc-ieg9kh-3"
})(["font-size:28px;line-height:32px;margin-bottom:14px;color:#17181a;font-weight:500;white-space:break-spaces;"]);
var Description = _styledComponents["default"].p.withConfig({
  displayName: "PriceChangePopupDesktop__Description",
  componentId: "sc-ieg9kh-4"
})(["font-size:14px;line-height:17px;margin-bottom:22px;color:#4d4d4d;", ""], function (_ref) {
  var priceIncreased = _ref.priceIncreased;
  return priceIncreased && "\n  white-space: break-spaces;\n  ";
});
var PriceDiff = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupDesktop__PriceDiff",
  componentId: "sc-ieg9kh-5"
})(["display:flex;margin-bottom:16px;justify-content:space-around;min-width:400px;"]);
var Amount = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "PriceChangePopupDesktop__Amount",
  componentId: "sc-ieg9kh-6"
})(["font-size:22px;line-height:26px;"]);
var OldPrice = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupDesktop__OldPrice",
  componentId: "sc-ieg9kh-7"
})(["color:#4d4d4d;min-width:125px;font-weight:normal;"]);
var NewPrice = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupDesktop__NewPrice",
  componentId: "sc-ieg9kh-8"
})(["color:#17181a;min-width:165px;", "{font-weight:500;}"], Amount);
var PriceTitle = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupDesktop__PriceTitle",
  componentId: "sc-ieg9kh-9"
})(["font-size:12px;line-height:14px;"]);
var Buttons = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupDesktop__Buttons",
  componentId: "sc-ieg9kh-10"
})(["margin-bottom:20px;display:flex;justify-content:center;align-items:center;min-width:400px;justify-content:space-around;flex-direction:row;"]);
var PaymentButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "PriceChangePopupDesktop__PaymentButton",
  componentId: "sc-ieg9kh-11"
})(["min-width:", "px;white-space:break-spaces;"], function (_ref2) {
  var priceDecreased = _ref2.priceDecreased;
  return priceDecreased ? 200 : 164;
});
var FireIcon = (0, _styledComponents["default"])(_HotPriceCircle["default"]).withConfig({
  displayName: "PriceChangePopupDesktop__FireIcon",
  componentId: "sc-ieg9kh-12"
})(["width:16px;height:16px;margin-right:4px;margin-bottom:-3px;"]);
var HotelLinkWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupDesktop__HotelLinkWrapper",
  componentId: "sc-ieg9kh-13"
})(["min-width:125px;"]);
var HotelLink = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "PriceChangePopupDesktop__HotelLink",
  componentId: "sc-ieg9kh-14"
})(["color:#007aff;text-decoration:none;white-space:break-spaces;"]);